var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotvisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0055 4.42105C15.0177 4.42105 17.4625 6.89684 17.4625 9.94737C17.4625 10.6658 17.3206 11.34 17.0696 11.97L20.2565 15.1974C21.9045 13.8047 23.2033 12.0032 24 9.94737C22.1119 5.09526 17.4516 1.65789 11.9945 1.65789C10.4666 1.65789 9.00409 1.93421 7.65075 2.43158L10.0082 4.81895C10.6303 4.56474 11.296 4.42105 12.0055 4.42105ZM1.09141 1.40368L3.57981 3.92368L4.08185 4.43211C2.27012 5.85789 0.851296 7.75895 0 9.94737C1.88813 14.7995 6.54843 18.2368 12.0055 18.2368C13.6971 18.2368 15.3124 17.9053 16.7858 17.3084L17.2442 17.7726L20.442 21L21.8281 19.5963L2.47749 0L1.09141 1.40368ZM7.12688 7.51579L8.81855 9.22895C8.76398 9.46105 8.73124 9.70421 8.73124 9.94737C8.73124 11.7821 10.1937 13.2632 12.0055 13.2632C12.2456 13.2632 12.4857 13.23 12.7149 13.1747L14.4065 14.8879C13.6753 15.2526 12.8677 15.4737 12.0055 15.4737C8.99318 15.4737 6.54843 12.9979 6.54843 9.94737C6.54843 9.07421 6.76671 8.25632 7.12688 7.51579ZM11.8308 6.65368L15.2688 10.1353L15.2906 9.95842C15.2906 8.12368 13.8281 6.64263 12.0164 6.64263L11.8308 6.65368Z",
    fill: "#8C8E86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotvisible);
export default __webpack_public_path__ + "static/media/notvisible.e50c6f7f9dbee4177a7f5fdb714bc488.svg";
export { ForwardRef as ReactComponent };